import {
    IProcess,
    IRobot,
} from '@models';

export enum JobType {
    Unattended = 0,
    Attended = 1,
}

export enum JobState {
    Pending = 0,
    Running = 1,
    Stopping = 2,
    Terminating = 3,
    Faulted = 4,
    Successful = 5,
    Stopped = 6,
    Suspended = 7,
    Resumed = 8,
}

export enum JobTriggerType {
    None = 0,
    QueueItem = 1,
    Job = 2,
    Task = 3,
    Timer = 4,
}

export enum JobTriggerStatus {
    New = 0,
    Ready = 1,
    Fired = 2,
}

export enum JobSource {
    Manual = 0,
    Schedule = 1,
    Agent = 2,
    Queue = 3,
}

export enum JobStartStrategy {
    AllRobots = 'All',
    SpecificRobots = 'Specific',
    JobsCount = 'JobsCount',
}

export interface IJob {
    key: string;
    startTime: Date;
    endTime: Date;
    id: number;
    info?: string;
    state: string;
    source: string;
    sourceType: 'Manual' | 'Schedule' | 'Agent';
    startingTriggerId: number;
    creationTime: Date;
    robot: IRobot;
    release: IProcess;
    environmentName: string;
    type: string;
    needsUpdate?: boolean;
    inputArguments: Record<string, any>;
    outputArguments: Record<string, any>;
    hostMachineName: string;
    hasMediaRecorded: boolean;
}

export interface IJobUpdated {
    jobId: number;
    robotName: string;
    isNew: boolean;
    state: string;
    startTime?: Date;
    endTime?: Date;
}

export interface IJobTrigger {
    id: number;
    jobId: number;
    status: keyof typeof JobTriggerStatus;
    triggerType: keyof typeof JobTriggerType;
    triggerMessage: string;
    itemId: number | null;
}

export interface IStartProcess {
    releaseKey: string;
    strategy: 'All' | 'Specific' | 'JobsCount' | string;
    robotIds: Array<number>;
    jobsCount: number;
    inputArguments: Record<string, any>;
}
